import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';

import Gallery from './pages/Gallery';
import Notices from './pages/Notices';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AboutUs from './pages/AboutUs';
import StudentLife from './pages/StudentLife';
import MandatoryDisclosure from './pages/MandatoryDisclosure';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Laboratory from './pages/Laboratory';
import ClubActivities from './pages/ClubActivities';
import Awards from './pages/Awards';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
		<Route path="/student-life" element={<StudentLife />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/notices" element={<Notices />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
		<Route path="/mandatory-disclosure" element={<MandatoryDisclosure />} />
		<Route path="/laboratory" element={<Laboratory />} />
		<Route path="/gallery" element={<Gallery />} />
		<Route path="/club-activities" element={<ClubActivities />} />
		<Route path="/awards" element={<Awards />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
